interface UserForwardedEmailsJson {
  id: number;
  email: string;
}

/**
 * @deprecated
 * should use js/src/domain/user_forwarded_email2.ts
 */
export class UserForwardedEmails {
  readonly id?: number;

  email: string;

  constructor(args?: UserForwardedEmailsJson) {
    if (args) {
      this.id = args.id;
      this.email = args.email;
    } else {
      this.email = '';
    }
  }

  setEmail(value: string) {
    this.email = value;
    app.render();
  }

  params() {
    return {
      id: this.id,
      email: this.email
    };
  }
}
